import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import { Button, TableRow, TableCell, TextField, Paper, Table, TableHead, TableBody, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Checkbox, CircularProgress, Tooltip, IconButton } from '@material-ui/core';
import { EmptyCollection, DeletePopUp, PageLoader, Pagination, STableLoader } from '../../../shared_elements';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/Edit';
import { regexConstants } from '../../../constants/regEx';
import { globalDeleteService, globalGetService, globalPostService, globalPutService } from '../../../utils_v2/globalApiServices';
import { checkApiStatus } from '../../../utils_v2';
import AddIcon from '@material-ui/icons/Add';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import Skeleton from '@material-ui/lab/Skeleton';
const additionalDataObj = {
    description:'',
    item:'',
    part_number:'',
    serial_number:'',
    remarks:''
}
const AddEditAdditionalData = ({params, toggleModalFn, addEditAdditionalData, getResponseBack}) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false)
    const [error, setError] = useState({});
    const [additionalData, setAddEditAdditionalData] = useState(addEditAdditionalData.data);
    
    const onFieldChange = (key, value) => {
      setAddEditAdditionalData({...additionalData, [key]:value})
    }
    const onAddEditAdditionalData = () => {
        let validationInputs = {
            description:additionalData?.description?.trim()?.length ? '':'Please enter Description',
        }
        if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === ''})){
            setLoading(true);
            if(additionalData.id){
                globalPutService(`technical/v2/workorder/${params.workOrderSlug}/powerplant-additional-data/${additionalData.id}/`, additionalData)
                .then(response => {
                    if(checkApiStatus(response)){
                        enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                        toggleModalFn(); getResponseBack();
                    }
                    setLoading(false);
                })
            }else{
                globalPostService(`technical/v2/workorder/${params.workOrderSlug}/powerplant-additional-data/`, {additional_data:[additionalData]})
                .then(response => {
                    if(checkApiStatus(response)){
                        enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                        toggleModalFn(); getResponseBack();
                    }
                    setLoading(false);
                })
            }
        }else{
            setError(validationInputs)
        }
    }
    return(
        <Dialog
            open={addEditAdditionalData.modal}
            onClose={toggleModalFn}
            className='project-management-modal'
            maxWidth='md'
        >
            <DialogTitle id="scroll-dialog-title">
                {additionalData.id ? 'Edit':'Add'} Additional Data
            </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            required
                            name="description"
                            label="Description"
                            fullWidth
                            margin="normal"
                            inputProps={{maxLength: 250}}
                            value={additionalData?.description||''}
                            onChange={(e) => onFieldChange('description', e.target.value)}
                            error={error?.description}
                            multiline
                            rows={3}
                            helperText={error?.description||''}
                            InputLabelProps={{shrink: true}}
                            onFocus={(e) => setError({...error,'description':''})}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <TextField
                            name="item"
                            label="Item No"
                            fullWidth
                            margin="normal"
                            inputProps={{maxLength: 20}}
                            value={additionalData?.item||''}
                            onChange={(e) => onFieldChange('item', e.target.value)}
                            error={error?.item}
                            helperText={error?.item||''}
                            InputLabelProps={{shrink: true}}
                            onFocus={(e) => setError({...error,'item':''})}
                            variant='outlined'
                        />
                    </Grid>
                    
                    <Grid item md={4} xs={12}>
                        <TextField
                            name="part_number"
                            label="Part Number"
                            fullWidth
                            margin="normal"
                            inputProps={{maxLength: 20}}
                            value={additionalData?.part_number||''}
                            onChange={(e) => onFieldChange('part_number', e.target.value)}
                            error={error?.part_number}
                            helperText={error?.part_number||''}
                            InputLabelProps={{shrink: true}}
                            onFocus={(e) => setError({...error,'part_number':''})}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <TextField
                            name="serial_number"
                            label="Serial Number"
                            fullWidth
                            margin="normal"
                            inputProps={{maxLength: 20}}
                            value={additionalData?.serial_number||''}
                            onChange={(e) => onFieldChange('serial_number', e.target.value)}
                            error={error?.serial_number}
                            helperText={error?.serial_number||''}
                            InputLabelProps={{shrink: true}}
                            onFocus={(e) => setError({...error,'serial_number':''})}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            name="remarks"
                            label="Remarks"
                            fullWidth
                            margin="normal"
                            inputProps={{maxLength: 250}}
                            value={additionalData?.remarks||''}
                            onChange={(e) => onFieldChange('remarks', e.target.value)}
                            error={error?.remarks}
                            multiline
                            rows={4}
                            helperText={error?.remarks||''}
                            InputLabelProps={{shrink: true}}
                            onFocus={(e) => setError({...error,'remarks':''})}
                            variant='outlined'
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color="primary" size="small" variant='outlined'>Cancel</Button>
                <Button disabled={isLoading} onClick={onAddEditAdditionalData} variant="contained" color="primary" size="small">
                    {isLoading ? <CircularProgress size={20} /> : 'SAVE' }
                </Button>
            </DialogActions>
        </Dialog>
    )
}
const AdditionalData = ({params, currentFormDetail, getCurrentFormDetail}) => {
    const { enqueueSnackbar } = useSnackbar();
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [additionalDataInfo, setAdditionalDataInfo] = useState({list:[], pagination:null});
    const [addEditAdditionalData, setAddEditAdditionalData] = useState({data:null, modal:false});
    const [deleteAdditionalData, setDeleteAdditionalData] = useState({data:[], modal:false});
    useEffect(() => {
        getAdditionalData({}, 'skeletonLoader');
    },[]);
    const getAdditionalData = (query, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true):setLoading(true);
        globalGetService(`technical/v2/workorder/${params.workOrderSlug}/powerplant-additional-data/`, query)
        .then(response => {
            if(checkApiStatus(response)){
                setAdditionalDataInfo(response.data.data);
            }
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false):setLoading(false);
        })
    }
    const handleChange = (type, flag, id) => {
        if(type === 'single'){
            setDeleteAdditionalData({
                ...deleteAdditionalData,
                data: flag ? [...deleteAdditionalData.data, id]:deleteAdditionalData.data.filter(item =>  item !== id)
            })
        }else{
            let ids = additionalDataInfo.list.map(item => item.id)
            setDeleteAdditionalData({
                ...deleteAdditionalData,
                data: flag ? ids:[]
            })
        }
    }
    const onDeleteAdditionalData = () => {
        setLoading(true);
        globalDeleteService(`technical/v2/workorder/${params.workOrderSlug}/powerplant-additional-data/`, {ids:deleteAdditionalData.data})
        .then(response => {
            if(checkApiStatus(response)){
                enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                setDeleteAdditionalData({modal:false, data:[]})
                getAdditionalData({}, 'pageLoader');
                getCurrentFormDetail('pageLoader');
            }
            setLoading(false);
        })
    }
    const canEdit = currentFormDetail?.current_form?.permissions?.can_save;
    return(
        <div className='forms-table-layout'>
            { skeletonLoader ?
                <>
                    <Paper className='forms-table-cta' square>
                        <Grid container spacing={1}>
                            <Grid item md={6}></Grid>
                            <Grid item md={6}>
                                <ul className='list-inline' style={{float:'right'}}>
                                    <li className='list-inline-item'>
                                        <Skeleton variant="rect" animation='wave' width={160} height={30} style={{borderRadius:4}} />
                                    </li>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <STableLoader count={6} />
                </>:
                <>
                    <Paper className='forms-table-cta' square>
                        <Grid container spacing={1}>
                            <Grid item md={6}></Grid>
                            <Grid item md={6}>
                                { canEdit ?
                                    <ul className='list-inline'>
                                        { deleteAdditionalData?.data?.length ?
                                            <li className='list-inline-item'>
                                                <Button startIcon={<DeleteOutlineIcon  fontSize='small' />} onClick={() => setDeleteAdditionalData({...deleteAdditionalData, modal:true})} color='secondary' size='small' variant='contained'>Delete ({deleteAdditionalData?.data?.length})</Button>
                                            </li>:null
                                        }
                                        <li className='list-inline-item'>
                                            <Button onClick={() => setAddEditAdditionalData({data:additionalDataObj, modal:true})} color='primary' size='small' variant='contained'><AddIcon style={{ fontSize: '1.15rem', color:'#fff' }} />Add Additional Data</Button>
                                        </li>
                                        <li className='list-inline-item' style={{display:'none'}}>
                                            <Button onClick={() => setAddEditAdditionalData({data:{}, modal:true})} color='primary' size='small' variant='outlined'><AddIcon color='primary' style={{ fontSize: '1.15rem' }} />Import</Button>
                                        </li>
                                        <li className='list-inline-item' style={{display:'none'}}>
                                            <Button onClick={() => setAddEditAdditionalData({data:{}, modal:true})} color='primary' size='small' variant='outlined'><SaveAltIcon style={{ fontSize: '1.15rem' }}/>Export</Button>
                                        </li>
                                    </ul>:null
                                }
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper className='forms-table-content'>
                        <div style={{height: !additionalDataInfo.list.length ? 'auto':`${window.innerHeight-290}px`,overflow:'auto'}}>
                            <Table className='mui-table-format' stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        { canEdit ?
                                            <TableCell style={{width:'40px'}}>
                                                <div style={{width:'40px'}}>
                                                <Checkbox
                                                    size='small'
                                                    checked={deleteAdditionalData?.data?.length ? deleteAdditionalData?.data?.length === additionalDataInfo?.list.length :false}
                                                    onChange={(e) => handleChange('bulk', e.target.checked)}
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                    disabled={!additionalDataInfo?.list?.length}
                                                />
                                                </div>
                                            </TableCell>:null
                                        }
                                        <TableCell>Description</TableCell>
                                        <TableCell>Item No</TableCell>
                                        <TableCell>P/N</TableCell>
                                        <TableCell>S/N</TableCell>
                                        <TableCell>Remarks</TableCell>
                                        <TableCell align='right'>Action(s)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { additionalDataInfo.list.map((item, index) => 
                                        <TableRow key={index}>
                                            { canEdit ?
                                                <TableCell>
                                                    <div style={{width:'40px'}}>
                                                        <Checkbox
                                                            size='small'
                                                            checked={deleteAdditionalData.data.includes(item.id)}
                                                            onChange={(e) => handleChange('single', e.target.checked, item.id)}
                                                            inputProps={{ 'aria-label': 'primary checkbox' }}
                                                        />
                                                    </div>
                                                </TableCell>:null
                                            }
                                            <TableCell>
                                                <div style={{width:'380px'}}>{item?.description ||'--'}</div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{width:'100px'}}>{item?.item||'--'}</div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{width:'100px'}}>{item?.part_number ||'--'}</div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{width:'100px'}}>{item?.serial_number||'--'}</div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{width:'380px'}}>{item?.remarks||'--'}</div>
                                            </TableCell>
                                            <TableCell align='right'>
                                                { canEdit ? 
                                                    <ul className='list-inline' style={{width:'80px', float:'right'}}>
                                                        <li className='list-inline-item'>
                                                            <Tooltip title='Edit' arrow>
                                                                <IconButton size="small"><EditIcon onClick={() => setAddEditAdditionalData({modal:true, data:item})} fontSize='small' color='primary' /> </IconButton>
                                                            </Tooltip>
                                                        </li>
                                                        <li className='list-inline-item'>
                                                            <Tooltip title='Delete' arrow>
                                                                <IconButton size="small"> <DeleteOutlineIcon onClick={() => setDeleteAdditionalData({modal:true, data:[item.id]})} fontSize='small' color='secondary' /> </IconButton>
                                                            </Tooltip>
                                                        </li>
                                                    </ul>:null
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                        <Pagination 
                            pagination={additionalDataInfo.pagination}
                            onChangePage={(event, newPage) => getAdditionalData({...filter, page:newPage+1, per_page: additionalDataInfo.pagination.per_page}, 'pageLoader')}
                            onChangeRowsPerPage={(event) => getAdditionalData({...filter, page:1, per_page: event.target.value}, 'pageLoader')}
                        />
                        { !additionalDataInfo.list.length ? <EmptyCollection title="No records found" />:null }
                    </Paper>    
                </>
            }
            
            { addEditAdditionalData.modal ?
                <AddEditAdditionalData 
                    params={params}
                    addEditAdditionalData={addEditAdditionalData}
                    toggleModalFn={() => setAddEditAdditionalData({data:null, modal:false})}
                    getResponseBack={() => {getAdditionalData({}, 'pageLoader'); getCurrentFormDetail('pageLoader');}}
                />:null
            }
            { deleteAdditionalData.modal ?
                <DeletePopUp
                    modal={deleteAdditionalData.modal}
                    toggleModalFn={() => setDeleteAdditionalData({data:[], modal:false})}
                    title="Delete Additional Data(s)"
                    content={<h4>Are you sure you want to delete?</h4>}
                    deleteRecordFn={onDeleteAdditionalData}
                />:null
            }
            { isLoading ? <PageLoader/>:null }
        </div>
    )
}
export default withRouter(AdditionalData);
